import { render, staticRenderFns } from "./DealCustomerIdentityVerificationAction.vue?vue&type=template&id=0240264c&scoped=true"
import script from "./DealCustomerIdentityVerificationAction.vue?vue&type=script&lang=js"
export * from "./DealCustomerIdentityVerificationAction.vue?vue&type=script&lang=js"
import "./DealCustomerIdentityVerificationAction.vue?vue&type=style&index=0&id=0240264c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240264c",
  null
  
)

export default component.exports